import React from "react";

import styles from "./Pagination.module.scss";

const Pagination = ({
  totalPosts,
  postsPerPage,
  setCurrentPage,
  currentPage,
  maxPagesToShow = 10,
}) => {

  // Do not render pagination if there’s nothing to paginate
  if (!totalPosts || totalPosts <= postsPerPage) return null;

  const totalPages = Math.ceil(totalPosts / postsPerPage);
  let startPage, endPage;

  if (totalPages <= maxPagesToShow) {
    // less than max pages so show all
    startPage = 1;
    endPage = totalPages;
  } else {
    // more than maxPagesToShow pages, calculate start and end
    const maxPagesBeforeCurrentPage = Math.floor(maxPagesToShow / 2);
    const maxPagesAfterCurrentPage = Math.ceil(maxPagesToShow / 2) - 1;

    if (currentPage <= maxPagesBeforeCurrentPage) {
      // near the start
      startPage = 1;
      endPage = maxPagesToShow;
    } else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
      // near the end
      startPage = totalPages - maxPagesToShow + 1;
      endPage = totalPages;
    } else {
      // somewhere in the middle
      startPage = currentPage - maxPagesBeforeCurrentPage;
      endPage = currentPage + maxPagesAfterCurrentPage;
    }
  }

  const pages = [];
  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  return (
    <div className={styles.pagination}>
      <button
        onClick={() => setCurrentPage(1)}
        className={currentPage === 1 ? styles.active : ""}
        style={{ display: startPage == 1 ? "none" : "inline-block" }}
      >
        start
      </button>
      {pages.map((page) => (
        <button
          key={page}
          onClick={() => setCurrentPage(page)}
          className={page === currentPage ? styles.active : ""}
        >
          {page}
        </button>
      ))}
      <button
        onClick={() => setCurrentPage(totalPages)}
        className={currentPage === totalPages ? styles.active : ""}
        style={{ display: endPage == totalPages ? "none" : "inline-block" }}
      >
        end
      </button>
    </div>
  );
};

export default Pagination;
